<template>
  <v-container fluid>
    <v-flex xs12 justify-center align-center style="height: 100%;" v-if="items.length === 0 && searchText === ''">
      <v-img src="/empty_announcement.webp" class="center" style="height: 300px;width: 450px"></v-img>
      <v-alert
        shaped
        text
        type="info"
        max-width="400px"
        class="center"
      >{{ $t('announce.emptyPlaceholder') }}</v-alert>
    </v-flex>
    <v-flex justify-center align-center class="d-flex" v-else>
      <v-card>
        <v-data-table
          ref="announcementDataTable"
          :loading="loading"
          :loading-text="$t('announce.loading')"
          :headers="headers"
          :no-data-text="$t('announce.tip.noData')"
          :options.sync="pagination"
          :server-items-length="announcementPagination.total"
          :items-per-page="defaultItemPerPage"
          :footer-props="footerProps"
          :disable-sort="true"
          :items="items"
          height="calc(95vh - 56px - 56px)"
          :max-width="1000"
          id="announcements-iterator">
          <template v-slot:[`item.volumeGainDb`]="{ item }">
            {{ (item.volumeGainDb !== '' && item.volumeGainDb !== null) ? `${item.volumeGainDb} DB` : '' }}
          </template>
          <template v-slot:[`item.textType`]="{ item }">
            {{ item.textType ? $t(`announce.columnRenderer.channelTypes.${item.textType}`) : '' }}
          </template>
          <template v-slot:[`item.speed`]="{ item }">
            {{ item.speed ? `x${item.speed}` : '' }}
          </template>
          <template v-slot:[`item.formattedPostDest`]="{ item }">
            <v-icon v-if="item.formattedPostDest" color="green">mdi-check</v-icon>
            <v-icon v-else color="red">mdi-close</v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <Actions @reload="load" :data="item" :key="item.id"/>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import Actions from './actions'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'announcements',
  components: { Actions },
  data () {
    return {
      loading: false,
      pagination: {},
      defaultItemPerPage: 10,
      footerProps: {
        'items-per-page-options': [5, 10, 15, 18, 20, 25, 50, 100],
        pageText: this.$t('announce.footerProps.pageText'),
        'items-per-page-text': this.$t('announce.footerProps.total')
      },
      headers: [
        { text: this.$t('announce.columns.name'), value: 'name', align: 'center' },
        { text: this.$t('announce.columns.pin'), value: 'pin', align: 'center' },
        { text: this.$t('announce.columns.textToSpeech'), value: 'textToSpeech' },
        { text: this.$t('announce.columns.pitch'), value: 'pitch', align: 'center' },
        { text: this.$t('announce.columns.speed'), value: 'speed', align: 'center' },
        { text: this.$t('announce.columns.volumeGainDb'), value: 'volumeGainDb', align: 'center' },
        { text: this.$t('announce.columns.ttsLanguage'), value: 'ttsLanguage', align: 'center' },
        { text: this.$t('announce.columns.textType'), value: 'textType', align: 'center' },
        { text: this.$t('announce.columns.actions'), value: 'actions', width: '600px' }
      ]
    }
  },
  watch: {
    async pagination () {
      this.loading = true
      await this.setPage(this.pagination?.page)
      await this.setLimitPerPage(this.pagination?.itemsPerPage)
      await this.load()
      await this.initSearch(this.$t('announce.searchPlaceholder'))
      this.loading = false
    },
    async searchText () {
      await this.load()
    }
  },
  mounted () {
    this.load()
  },
  computed: {
    ...mapGetters({
      items: 'announcements/items',
      announcementPagination: 'announcements/pagination',
      searchText: 'search/searchText'
    })
  },
  methods: {
    ...mapActions({
      load: 'announcements/load',
      setPage: 'announcements/setPage',
      setLimitPerPage: 'announcements/setLimitPerPage',
      initSearch: 'search/init'
    })
  }
}
</script>

<style scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
